import { useContext, useEffect, useState } from 'react';

import { SpecialistContext } from 'context';

import TCDashboardTab from 'components/TCDashboardTab';
import { TabName, TabState } from 'components/TCDashboardTab/types';

import { TCDashboardTabsProps } from './types';

import * as S from './styles';

const TCDashboardTabs: React.FC<TCDashboardTabsProps> = ({
  loading,
  tabsData,
  onTabSelected,
}) => {
  const { specialistInfo } = useContext(SpecialistContext);
  const showActivitiesByGeoCode =
    typeof specialistInfo?.geoCode !== 'undefined' &&
    specialistInfo.geoCode === 'BR';

  const getTabsData = tabsData
    .filter(({ name }) => {
      if (!showActivitiesByGeoCode) {
        const restrictedTabsByGeoCode = [
          TabName.FINISHING_PROGRAM,
          TabName.DISENGAGED,
          TabName.NOT_INITIALIZED,
          TabName.ENGAGED,
        ];

        return !restrictedTabsByGeoCode.includes(name);
      }

      return true;
    })
    .map(({ name, type, amount, state, keyName }) => {
      return {
        name,
        type,
        amount,
        keyName,
        state: state || TabState.DISABLED,
      };
    });

  const [tabs, setTabs] = useState(getTabsData);

  const handleTabSelection = (tabName: TabName) => {
    const selectedTab = tabs.find(({ name }) => tabName === name);

    if (selectedTab?.state === TabState.INACTIVE) {
      onTabSelected(tabName);

      const updatedTabs = tabs.map(tab => {
        let updatedTab;

        if (tab.name === tabName) {
          updatedTab = { ...tab, state: TabState.ACTIVE };
        } else if (tab.state === TabState.DISABLED) {
          updatedTab = tab;
        } else {
          updatedTab = { ...tab, state: TabState.INACTIVE };
        }

        return updatedTab;
      });

      setTabs(updatedTabs);
    }
  };

  useEffect(() => {
    if (!loading) {
      setTabs(getTabsData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <S.TCDashboardTabsContainer data-testid="TCDashboardTabsContent">
      {tabs.map(({ name, type, amount, state, keyName }) => {
        return (
          <TCDashboardTab
            key={name}
            type={type}
            name={name}
            state={state}
            amount={amount}
            keyName={keyName}
            onSelect={handleTabSelection}
          />
        );
      })}
    </S.TCDashboardTabsContainer>
  );
};

export default TCDashboardTabs;
